import { ROLES } from '@/constants/roles';

export default [
  {
    path: '/products',
    name: 'product_list',
    component: () => import('@/views/pages/products/ProductList.vue'),
    meta: {
      pageTitle: 'Product List',
      breadcrumb: {
        label: 'Product List'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN, ROLES.CUSTOMER_MANAGER, ROLES.CUSTOMER_USER],
      verticalMenu: {
        title: 'Product List',
        icon: 'AnchorIcon'
      }
    }
  },
  {
    path: '/products/create',
    name: 'create_product',
    component: () => import('@/views/pages/products/CreateProduct.vue'),
    meta: {
      pageTitle: 'Create Product',
      breadcrumb: {
        label: 'Create Product',
        parent: 'product_list'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN, ROLES.CUSTOMER_MANAGER, ROLES.CUSTOMER_USER]
    }
  },
  {
    path: '/products/:id',
    name: 'edit_product',
    component: () => import('@/views/pages/products/EditProduct.vue'),
    meta: {
      pageTitle: 'Edit Product',
      breadcrumb: {
        label: 'Edit Product',
        parent: 'product_list'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN, ROLES.CUSTOMER_MANAGER, ROLES.CUSTOMER_USER]
    }
  }
];
